export interface ClientState {
  clients: ClientModel[]
  client: ClientModel
  selectedRows?: number
  currentPage: number
}

export const GET_CLIENT = 'GET_CLIENT'
export const GET_LIST_CLIENTS = 'GET_LIST_CLIENTS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
